import { type FC, type ReactNode } from 'react';

import { useStyles } from './SelectBar.styles';

export type SelectBarProps = {
	/** Unique identifier */
	id: string;
	/** Whether the selectBar component is disabled */
	isDisabled?: boolean;
	/** Whether the selectBar component is selected */
	selected?: boolean;
	/** Passed styling */
	className?: string;
	dataCy?: string;
	/** Selector component */
	selector?: ReactNode;
	/** Content component */
	content: ReactNode;
	/** Label component */
	tag?: ReactNode;
};

export const SelectBar: FC<SelectBarProps> = ({
	id,
	tag,
	isDisabled,
	className,
	dataCy,
	selected,
	selector,
	content,
}) => {
	const { classes, cx } = useStyles();

	return (
		<label
			className={cx(classes.selectBarContainer, { [classes.disabled]: isDisabled }, className)}
			data-cy={selected ? `${dataCy}-selectBar-selected` : `${dataCy}-selectBar`}
			htmlFor={id}
		>
			<div className={classes.contentContainer}>
				<div className={classes.selectBarOptionContainer}>{selector}</div>
				<div className={classes.textContainer}>{content}</div>
				<div className={classes.labelContainer} data-cy={`${dataCy}-labelContainer`}>
					{tag}
				</div>
			</div>
		</label>
	);
};
